<template>
    <div class="horizontal-tab-item">
        <flow-container :children="props.tpl.children"></flow-container>
    </div>
</template>


<script >
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
const __sfc_main = {
  components: {
    FlowContainer: ComplexComp.Container.Flow
  }
};
__sfc_main.props = {
  tpl: Object
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;
  return {
    props
  };
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.horizontal-tab-item {
    display: flex;
    height: 100% !important;
    align-items: center;
    justify-content: center;
    transition: all .4s ease;
}
</style>
